import { render, staticRenderFns } from "./JourneyFlow.vue?vue&type=template&id=47344631&scoped=true"
import script from "./JourneyFlow.vue?vue&type=script&lang=js"
export * from "./JourneyFlow.vue?vue&type=script&lang=js"
import style0 from "./JourneyFlow.vue?vue&type=style&index=0&id=47344631&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47344631",
  null
  
)

export default component.exports